export default __webpack_public_path__ + "72be416a759e04f8f76460c74742dbc2.png";